import React from 'react'
import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'lodash'

import OrderStore from '../stores/OrderStore.js'
import OrderActions from '../actions/OrderActions.js'
import AddressStore from '../../src/stores/AddressStore.js'
import dbCodes from '../../server/dbCodes.js'
import {getAllowedColliTypes} from '../../utils/getAllowedColliTypes.js'

import {ScrollContainer, TopBar, Select} from '../components/UI/index.js'
import {Alert, Button, Card, Colors, IconButton, ListItem, P, Row, S1, S2, Popup, H5, Icon, Badge, Link, Stack} from '../../src/components/UI/index.js'
import {formSpacing, FormStack, TextArea, Input, Toggle} from '../../src/components/UI/forms/index.js'
import {Signature, ScanFrame} from '../components/index.js'
import {ColliList, PackagesList} from '../components/ColliList.js'
import {OptionIcons, CustomOptionBadges} from '../components/OptionIcons.js'
import DeliverPopup from '../components/DeliverPopup.js'
import PickupPopup from '../components/PickupPopup.js'
import LinkBarcodePopup from '../components/LinkBarcodePopup.tsx'
import ImageLightbox from '../components/ImageLightbox.tsx'
import CameraScreen from '../components/CameraScreen.tsx'
import OriginalAddressRow from '../components/OriginalAddressRow.js'
import AddAddressModal from '@components/AddAddressModal.js'
import geolocation from '../utils/geolocation.js'
import calcDistance from '../../utils/calcDistance.js'
import utils from '../utils/utils.js'
import questionOptions from '../utils/questionOptions.js'
import stopBundles from '../../utils/stopBundles.js'
import {fileToJpegDataUrl} from '../utils/imageToJpeg.js'
import {base64ImageToDataUrl} from '../../utils/imageDataUrl.js'
import {isRetourOrder} from '../../utils/retourAddresses.js'
import {chooseColloStatus, choosePackagingStatus, colloStatuses} from '../utils/colloStatus.js'
import {emit} from 'messenger/socketio/socketEmit.js'
import t from 'src/helpers/Languages.js'
import {resolveMessengerRouteSettings, canAddOrderToRouteWithWarningSetting} from '../../utils/routeAdjustability.js'
import {getScannedAddressIndex, getScannedAddressType} from '../../utils/scannedOrderAddress.js'

const MAX_IMAGES = 5

function stopName(stop) {
    return stop.address.name || `${stop.address.street} ${stop.address.nr}${stop.address.addition}`
}

function stopSender(stop) {
    return stop.order.senderAddress?.name || stop.order.customerAddress?.name || ''
}

// The address index a collo is handled at, for this address type
function colloAddressIndexKey(type) {
    return type === 'pickup' ? 'pickupAddressIndex' : 'deliveryAddressIndex'
}

function getNotPossibleReasons(customerId, type) {
    return new Promise((resolve) => {
        OrderActions.getNotPossibleReasons(customerId, type, (err, reasons) => {
            if (err) {
                console.log(err)
            }

            resolve(type === 'pickup' ?
                {reasons: reasons?.pickupNotPossibleReasons || [], specifications: reasons?.pickupNotPossibleReasonsSpecifications || []} :
                {reasons: reasons?.deliveryNotPossibleReasons || [], specifications: reasons?.deliveryNotPossibleReasonsSpecifications || []})
        })
    })
}

function getAddressPackages(type, order, address) {
    return new Promise((resolve) => {
        OrderActions.getAddressPackages(type === 'pickup' ? 'pickup' : 'deliver', order.packagingIds, address, (err, packages) => {
            if (err) {
                console.log(err)
            } else {
                packages.map((packaging) => {
                    packaging.initialStatus = packaging.status

                    if (type === 'pickup') {
                        packaging.status = packaging.status === 'registered' ? 'collected' : ''
                    } else {
                        packaging.status = packaging.status === 'collected' || packaging.status === 'athub' ? 'delivered' : ''
                    }
                })
            }

            resolve(packages || [])
        })
    })
}

// The delivery addresses the colli picked up at a stop go to
function stopDeliveryAddresses(stop) {
    const deliveryAddresses = stop.order.addresses.filter((address) => address.type === 'delivery')

    if (deliveryAddresses.length !== 1) {
        return deliveryAddresses.filter((address) => stop.colli.some((collo) => collo.deliveryAddressIndex === address.index))
    }

    return deliveryAddresses
}

function imageSrc(image) {
    return image?.src || image
}

function openAttachment(attachment) {
    OrderActions.downloadAttachment(attachment.fileId, (err, file) => {
        if (err) {
            console.log(err)
        } else {
            const raw = window.atob(file)
            const array = new Uint8Array(new ArrayBuffer(raw.length))

            for (let i = 0; i < raw.length; i++) {
                array[i] = raw.charCodeAt(i)
            }

            window.open(URL.createObjectURL(new Blob([array], {type: attachment.type})))
        }
    })
}

// Pickup or delivery of one stop, or of a bundle: stops at the same address that are handled at once. Every field
// applies to all stops, except the colli, emballage and verification codes which are per stop. A completed stop can be
// opened again to correct it (#701), it is always corrected on its own.
class Stop extends Reflux.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            view: 'main',
            type: '',
            stops: null,
            edit: false,
            hasSignature: false,
            showCamera: false,
            showCopyTooltip: false,
            expandSenders: false,
            expandDeliveryAddresses: false,
            possible: true,
            status: '',
            reason: '',
            reasonSpecification: '',
            deliveredAtNeighbors: false,
            deliveredInMailbox: false,
            nrNeighbor: '',
            signee: '',
            ageVerified: false,
            documentId: '',
            comment: '',
            scanned: [],
            hasScanned: false,
            signature: '',
            images: [],
            showImageLightbox: false,
            selectedImageIndex: -1,
            skipScannedOrderPopup: false,
            errors: [],
            loading: false,
            error: '',
            submitProcess: '',
            showSlowSubmitWarning: false
        }

        this.state = {...this.initialState}

        this.submitProcessTimeout = null
        this.tooltipTimeout = null
        this.verificationCodeInputs = {}

        this.stores = [OrderStore, AddressStore]
    }

    componentDidMount() {
        this.load()
    }

    componentDidUpdate(prevProps) {
        const {orderId, addressIndex} = this.props.match.params

        if (orderId !== prevProps.match.params.orderId || addressIndex !== prevProps.match.params.addressIndex || this.props.bundle !== prevProps.bundle) {
            this.setState({showCamera: false})
            this.load()
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount.call(this)
        clearTimeout(this.submitProcessTimeout)
        clearTimeout(this.tooltipTimeout)
    }

    load() {
        const {location, bundle} = this.props
        const {orderId} = this.props.match.params
        const addressIndex = parseInt(this.props.match.params.addressIndex)

        if (location?.state?.edit) {
            this.loadCorrection(orderId, addressIndex)
        } else if (bundle) {
            this.loadBundle(orderId, addressIndex)
        } else {
            this.loadStop(orderId, addressIndex)
        }
    }

    loadStop(orderId, addressIndex) {
        const {route} = this.state
        const {history} = this.props
        const address = route.orders?.[orderId]?.addresses[addressIndex]

        if (!address) {
            history.push(localStorage.lastView || '/koerier/adressen')
            return
        }

        // A stop opened on its own is handled whether or not it is ready
        this.loadStops(address.type, [{id: address.id || `${orderId} ${addressIndex}`, orderId, index: addressIndex, isReady: true}])
    }

    loadBundle(orderId, addressIndex) {
        const {route} = this.state
        const {history, location} = this.props

        const bundle = stopBundles.findBundle(route.todoItems, orderId, addressIndex)

        if (!bundle) {
            // The bundle no longer exists (e.g. only one open stop is left), open the stop on its own if it is still open
            const address = route.orders?.[orderId]?.addresses[addressIndex]

            history.replace(address && !address.hasArrived ? stopBundles.stopPath(address) : (localStorage.lastView || '/koerier/adressen'), location?.state)
            return
        }

        this.loadStops(bundle.type, bundle.addresses)
    }

    /**
     * Opens a completed stop to change it (#701), with everything as it was filled in when the stop was completed
     */
    async loadCorrection(orderId, addressIndex) {
        try {
            const {order, historyEntry, images} = await emit('orders.getMessengerCorrectionOrder', {orderId, addressIndex})
            const address = order.addresses[addressIndex]
            const type = address.type
            const {ok, notOk} = colloStatuses[type]

            const colli = (historyEntry.colli || []).map((collo) => order.colli[collo.index])

            // A collo picked up at the stop has moved on since, e.g. to outfordelivery
            if (type === 'pickup') {
                colli.forEach((collo) => {
                    if (collo.status !== notOk) {
                        collo.status = ok
                    }
                })
            }

            const possible = !colli.length || colli.some((collo) => collo.status === ok)

            // A stop that wasn't completed opens on the regular page, as if the messenger arrives at the address again
            if (!possible) {
                colli.forEach((collo) => {
                    collo.status = collo.barcode && address.scanRequired ? '' : ok
                    collo.reason = ''
                })
            }

            const stop = {
                id: `${orderId} ${addressIndex}`,
                order,
                addressIndex,
                address,
                ready: true,
                status: '',
                colli,
                originalColli: structuredClone(colli),
                // The packaging was already handled when the stop was completed
                packages: [],
                verificationCode: historyEntry.verificationCode || '',
                customOptions: address.customOptions || [],
                reasons: await getNotPossibleReasons(order.customer, type)
            }

            this.setState({
                ...this.initialState,
                type,
                stops: [stop],
                edit: true,
                deliveredAtNeighbors: type === 'delivery' && colli.some((collo) => collo.status === ok && collo.deliveredAtNeighbors),
                nrNeighbor: colli.find((collo) => collo.nrNeighbor)?.nrNeighbor || '',
                deliveredInMailbox: type === 'delivery' && colli.some((collo) => collo.status === ok && collo.deliveredInMailbox),
                signee: historyEntry.signee || '',
                documentId: historyEntry.documentId || '',
                ageVerified: possible && !!address.minimumAge,
                comment: historyEntry.comment || '',
                scanned: historyEntry.scanned || [],
                hasScanned: !!historyEntry.scanned?.length,
                // A changed stop keeps the signature it was completed with
                hasSignature: possible && !!historyEntry.signatureId,
                images: images.map(({id, image}) => ({id, src: base64ImageToDataUrl(image)}))
            })
        } catch (err) {
            this.setState({error: typeof err === 'string' ? err : err?.message})
        }
    }

    async loadStops(type, routeAddresses) {
        const {route} = this.state
        const {location} = this.props

        const addressIndexKey = colloAddressIndexKey(type)
        const outStatus = type === 'pickup' ? 'outforpickup' : 'outfordelivery'

        // Stops of the same order share one copy of it, so colli added to the order get unique indexes
        const orders = {}

        const stops = routeAddresses.map((routeAddress) => {
            orders[routeAddress.orderId] = orders[routeAddress.orderId] || structuredClone(route.orders[routeAddress.orderId])

            const order = orders[routeAddress.orderId]
            const address = order.addresses[routeAddress.index]
            const colli = []

            if (routeAddress.isReady) {
                // Colli are handled unless scanning is required
                order.colli.map((collo) => {
                    if (collo[addressIndexKey] === routeAddress.index && collo.status === outStatus) {
                        collo.status = !collo.barcode || !address.scanRequired ? colloStatuses[type].ok : ''
                        collo.reason = ''

                        colli.push(collo)
                    }
                })
            }

            return {
                id: routeAddress.id,
                order,
                addressIndex: routeAddress.index,
                address,
                ready: !!routeAddress.isReady,
                status: routeAddress.isReady ? '' : Colors.addressStatusColor(routeAddress, routeAddress.colli).status,
                colli,
                originalColli: structuredClone(colli),
                packages: [],
                verificationCode: '',
                customOptions: address.customOptions || [],
                reasons: {reasons: [], specifications: []}
            }
        })

        const activeStops = stops.filter((stop) => stop.ready)

        const reasonsByCustomer = {}

        await Promise.all(_.uniq(activeStops.map((stop) => stop.order.customer)).map(async (customerId) => {
            reasonsByCustomer[customerId] = await getNotPossibleReasons(customerId, type)
        }))

        const packagesByStop = await Promise.all(activeStops.map((stop) => getAddressPackages(type, stop.order, stop.address)))

        const packagingIds = []

        activeStops.forEach((stop, index) => {
            stop.reasons = reasonsByCustomer[stop.order.customer]

            // Emballage at this address that belongs to no order of the bundle (e.g. a Px to collect) is listed once
            stop.packages = packagesByStop[index].filter((packaging) => {
                const ownPackaging = (stop.order.packagingIds || []).includes(packaging._id)
                const listed = packagingIds.includes(packaging._id)

                packagingIds.push(packaging._id)

                return ownPackaging || !listed
            })
        })

        this.setState({
            ...this.initialState,
            type,
            stops,
            deliveredInMailbox: type === 'delivery' && stopBundles.combineOptions(activeStops.map((stop) => stop.address)).mailboxDelivery
        }, () => {
            if (location?.state?.barcode) {
                this.onScan(location.state.barcode)
            }
        })
    }

    startSubmitProgress(process) {
        clearTimeout(this.submitProcessTimeout)

        const timeout = setTimeout(() => {
            // Guard against a stale timeout firing after stopSubmitProgress() or a restarted submit
            if (this.submitProcessTimeout === timeout && this.state.loading) {
                this.setState({showSlowSubmitWarning: true})
            }
        }, 3000)

        this.submitProcessTimeout = timeout
        this.setState({loading: true, error: '', submitProcess: process, showSlowSubmitWarning: false})
    }

    stopSubmitProgress(state = {}) {
        clearTimeout(this.submitProcessTimeout)
        this.submitProcessTimeout = null

        this.setState({loading: false, submitProcess: '', showSlowSubmitWarning: false, ...state})
    }

    activeStops() {
        return (this.state.stops || []).filter((stop) => stop.ready)
    }

    bundleReasons() {
        return stopBundles.intersectNotPossibleReasons(this.activeStops().map((stop) => stop.reasons))
    }

    // Stops with at least one handled collo, the options of only these stops apply
    handledStops() {
        const {type, possible} = this.state

        return possible ? this.activeStops().filter((stop) => stop.colli.some((collo) => collo.status === colloStatuses[type].ok)) : []
    }

    onChangePossible(possible) {
        const {type, scanned} = this.state
        const stops = [...this.state.stops]

        this.activeStops().forEach((stop) => {
            stop.colli.forEach((collo) => {
                const scanPending = stop.address.scanRequired && collo.barcode && !scanned.includes(collo.barcode)

                collo.status = possible ? (scanPending ? '' : colloStatuses[type].ok) : colloStatuses[type].notOk
                collo.reason = ''
            })
        })

        this.setState({possible, stops, status: '', reason: '', reasonSpecification: ''}, () => {
            if (!this.state.possible) {
                this.reasonInput?.focus()
            }
        })
    }

    onChangeReason(event) {
        const {type} = this.state
        const stops = [...this.state.stops]

        // For a delivery the reason select has the status as value and the reason as subvalue
        const status = type === 'pickup' ? colloStatuses.pickup.notOk : event.target.value
        const reason = type === 'pickup' ? event.target.value : event.target.subvalue

        this.activeStops().forEach((stop) => {
            stop.colli.forEach((collo) => {
                collo.status = status
                collo.reason = reason
            })
        })

        this.setState({stops, status, reason, reasonSpecification: ''}, () => {
            if (this.reasonSpecifications().length > 0) {
                this.reasonSpecificationInput?.focus()
            }

            if (this.state.reason === 'other') {
                this.commentInput?.focus()
            }
        })
    }

    reasonSpecifications() {
        const {type, status, reason} = this.state

        return this.bundleReasons().specifications.filter((specification) => {
            if (type === 'pickup') {
                return specification.reason === reason
            }

            const specStatus = specification.reason.split(';')[0]
            const specReason = specification.reason.split(';')[1]

            if (specReason) {
                return specReason === reason
            }

            return specStatus === status
        })
    }

    async onClickCollo(stop, collo, number) {
        const {type, scanned} = this.state
        let {hasScanned} = this.state
        const stops = [...this.state.stops]

        if (await chooseColloStatus(this.popup, {type, collo, colli: stop.colli, scanned, scanRequired: stop.address.scanRequired, reasons: stop.reasons.reasons, specifications: stop.reasons.specifications, reseller: this.props.reseller, number})) {
            hasScanned = true
        }

        this.setState({stops, scanned, hasScanned})
    }

    async onClickPackaging(packaging) {
        const {type} = this.state
        const stops = [...this.state.stops]

        await choosePackagingStatus(this.popup, type, packaging)

        this.setState({stops})
    }

    // Lets the messenger choose one of the stops, returns null when cancelled
    async chooseStop(title, text) {
        const activeStops = this.activeStops()

        if (activeStops.length === 1) {
            return activeStops[0]
        }

        const option = await this.popup.openOptions(title, text, [
            ...activeStops.map((stop) => (
                <ListItem key={stop.id} onClick={() => this.popup.onClickOption({value: stop.id})} style={{padding: '8px 0'}}>
                    <div style={{flex: 1, minWidth: 0}}>
                        <S1 ellipsis translate='no'>{stopName(stop)}</S1>
                        <P ellipsis translate='no'>{stopSender(stop)}</P>
                    </div>

                    <P style={{marginLeft: 6}}>{t('colliCount', stop.colli.length)}</P>
                </ListItem>
            )),
            <ListItem key='cancel' onClick={() => this.popup.onClickOption({value: ''})} style={{padding: '8px 0'}}>
                <P>{t('cancel')}</P>
            </ListItem>
        ])

        return activeStops.find((stop) => stop.id === option?.value) || null
    }

    async onScan(barcode) {
        const {type, route, skipScannedOrderPopup} = this.state
        const {reseller, branding} = this.props
        const stops = [...this.state.stops]
        const scanned = [...this.state.scanned]
        const originalScanned = [...this.state.scanned]
        const activeStops = this.activeStops()
        const okStatus = colloStatuses[type].ok
        const addressIndexKey = colloAddressIndexKey(type)

        const messengerRouteSettings = resolveMessengerRouteSettings(route, reseller.settings)
        const messengerAddOrderWarning = messengerRouteSettings.messengerAddOrderWarning
        const showWarningOnAddExistingOrder = messengerRouteSettings.showWarningOnAddExistingOrder
        const allowAddCollo = messengerRouteSettings.source === 'route' ?
            (route?.allowAddCollo ?? activeStops[0]?.order.allowAddCollo ?? '') :
            (messengerRouteSettings.source === 'reseller' ? (reseller.settings.allowAddCollo ?? activeStops[0]?.order.allowAddCollo ?? '') : '')

        this.setState({hasScanned: true})

        // Registers the scan only at the stop the collo belongs to
        const setScanned = (stop, collo) => {
            collo.status = okStatus
            collo.reason = ''

            if (!stop.colli.includes(collo)) {
                stop.colli.push(collo)
            }

            this.setState({stops, scanned: _.uniq([...scanned, barcode]), errors: []})
            this.scanFrame?.setMessage(`${collo.barcode}${collo.type ? ` (${collo.type})` : ''}`)
            this.scanFrame?.input?.focus()
        }

        const addExternalBarcode = (stop, details) => {
            if (!details && stop.colli.length === 1 && !stop.colli[0].barcode) {
                stop.colli[0].barcode = barcode
                stop.colli[0].status = okStatus
                stop.colli[0].reason = ''
            } else {
                const collo = {
                    index: stop.order.colli.length,
                    type: details?.type || '',
                    description: details?.description || '',
                    weight: 0,
                    length: 0,
                    width: 0,
                    height: 0,
                    barcode,
                    [addressIndexKey]: stop.addressIndex,
                    status: okStatus,
                    reason: '',
                    isNewCollo: true
                }

                stop.order.colli.push(collo)
                stop.colli.push(collo)
            }

            this.setState({stops, scanned: _.uniq([...scanned, barcode]), errors: []})
            this.scanFrame?.setMessage(barcode)
        }

        const linkBarcodeToCollo = (targetCollo, details) => {
            // stop.colli holds the same collo objects as stop.order.colli, so linking here updates both
            targetCollo.barcode = barcode
            targetCollo.status = okStatus
            targetCollo.reason = ''
            targetCollo.type = details?.type || targetCollo.type || ''
            targetCollo.description = details?.description || targetCollo.description || ''

            this.setState({stops, scanned: _.uniq([...scanned, barcode]), errors: []})
            this.scanFrame?.setMessage(barcode)
        }

        // Adds an unknown barcode to one of the stops, linked to a collo without barcode when there is one. After the
        // messenger already chose to take the collo along, it is added without asking for its details. Returns whether
        // the barcode was added.
        const addUnknownBarcode = async (takenAlong = false) => {
            const stop = await this.chooseStop(t('addBarcode'), t('addBarcodeToWhichStop', barcode))

            if (!stop) {
                this.setState({hasScanned: originalScanned.length > 0})
                this.scanFrame?.input?.focus()
                return false
            }

            const colliWithoutBarcode = stop.colli.filter((collo) => !collo.barcode)

            if (takenAlong) {
                addExternalBarcode(stop)
                this.scanFrame?.input?.focus()
                return true
            }

            // Link the barcode to a collo without barcode, or add it as a new collo when every collo already has one
            const result = await this.linkBarcodePopup.open({
                barcode,
                colli: colliWithoutBarcode,
                colliTypes: getAllowedColliTypes(reseller, this.state.customers?.[stop.order.customer]),
                nextColloNumber: stop.order.colli.length + 1,
                linkDirectly: colliWithoutBarcode.length > 0 && stop.colli.length === 1,
                warning: colliWithoutBarcode.length ? '' : t(type === 'pickup' ? 'scannedBarcodeNoMatchPickup' : 'scannedBarcodeNoMatchDelivery')
            })

            if (result?.collo) {
                linkBarcodeToCollo(result.collo, result)
            } else if (result) {
                addExternalBarcode(stop, result)
            } else {
                this.setState({hasScanned: originalScanned.length > 0})
            }

            this.scanFrame?.input?.focus()

            return !!result
        }

        // A collo of a stop in this bundle
        for (const stop of activeStops) {
            const collo = stop.order.colli.find((collo) => collo.barcode === barcode && (stop.colli.includes(collo) || collo[addressIndexKey] === stop.addressIndex))

            if (collo) {
                setScanned(stop, collo)
                return
            }
        }

        // A collo of an order in this bundle without an address yet
        for (const stop of activeStops) {
            const collo = stop.order.colli.find((collo) => collo.barcode === barcode && typeof collo[addressIndexKey] !== 'number')

            if (collo) {
                collo[addressIndexKey] = stop.addressIndex
                setScanned(stop, collo)
                return
            }
        }

        // Emballage to collect
        for (const stop of activeStops) {
            const packaging = stop.packages.find((packaging) => packaging.initialStatus === 'delivered' && packaging.barcode === barcode)

            if (packaging) {
                packaging.status = 'collected'

                this.setState({stops})
                this.scanFrame?.setMessage(`${packaging.barcode}${packaging.type ? ` (${packaging.type})` : ''}`)
                this.scanFrame?.input?.focus()
                return
            }
        }

        // A collo of a stop in this bundle that is not ready yet
        const notReadyStop = stops.find((stop) => !stop.ready && stop.order.colli.some((collo) => collo.barcode === barcode && collo[addressIndexKey] === stop.addressIndex))

        if (notReadyStop) {
            this.setState({hasScanned: originalScanned.length > 0})
            this.scanFrame?.setError(t('barcodeOfNotReadyStop', stopName(notReadyStop)))
            return
        }

        // A collo of an order in this bundle that has to be delivered at another address
        if (type === 'delivery') {
            const stop = activeStops.find((stop) => stop.order.colli.some((collo) => collo.barcode === barcode))

            if (stop) {
                if (await this.confirmPopup.openBoolean(t('attention'), t('barcodeOfOtherAddress'), questionOptions())) {
                    const collo = stop.order.colli.find((collo) => collo.barcode === barcode)

                    collo[addressIndexKey] = stop.addressIndex
                    setScanned(stop, collo)
                }
                return
            }
        }

        let foundOrder = false
        let showedScannedOrderPopup = false

        if (messengerAddOrderWarning !== 'notallowed' && !skipScannedOrderPopup) {
            try {
                const response = await emit('orders.findByBarcode', barcode)
                const deliveryOrder = response.find((foundOrder) => foundOrder.colli?.some((collo) => {
                    return collo.barcode === barcode && typeof collo.deliveryAddressIndex === 'number'
                }))

                const orderToScan = deliveryOrder || response[0]
                const scannedOrder = orderToScan && await emit('orders.scan', {id: orderToScan._id, barcode, noScan: true})
                const isDifferentOrder = scannedOrder && !stops.some((stop) => `${stop.order._id}` === `${scannedOrder._id}`)
                const canAddScannedOrderToRoute = canAddOrderToRouteWithWarningSetting(messengerAddOrderWarning, scannedOrder, route)
                const isInCurrentRoute = scannedOrder && `${scannedOrder.routeId || ''}` === `${route?._id || ''}`

                if (isDifferentOrder && isInCurrentRoute) {
                    showedScannedOrderPopup = true
                    foundOrder = true

                    const scannedAddressIndex = getScannedAddressIndex(scannedOrder, barcode)
                    const scannedAddressType = getScannedAddressType(scannedOrder, barcode)

                    this.popup.setActionButtons([
                        {
                            variant: 'solid',
                            label: t('openAddress'),
                            color: branding?.color || Colors.brandColor,
                            icon: 'mdi mdi-arrow-right-bold-circle',
                            onClick: () => {
                                this.popup.close()

                                if (typeof scannedAddressIndex === 'number') {
                                    const scannedBundle = stopBundles.findBundle(route.todoItems, scannedOrder._id, scannedAddressIndex)

                                    this.props.history.replace(scannedBundle ? stopBundles.stopPath(scannedBundle) : stopBundles.stopPath({type: scannedAddressType, orderId: scannedOrder._id, index: scannedAddressIndex}), {barcode})
                                }
                            },
                            style: {
                                width: 'unset'
                            }
                        }
                    ])

                    if (!await this.popup.open(t('addressInCurrentRoute'), t('barcodeOfAddressInCurrentRoute'))) return
                    this.scanFrame?.input?.focus()
                }

                if (isDifferentOrder && canAddScannedOrderToRoute && !isInCurrentRoute) {
                    showedScannedOrderPopup = true
                    foundOrder = true
                    let addToRoute = false
                    let doNotAddToRoute = false
                    let cancelled = false

                    let popupOptionsResult

                    const isPickupAddress = getScannedAddressType(scannedOrder, barcode) === 'pickup'

                    this.popup.setActionButtons([
                        {
                            variant: 'outline-white',
                            label: isPickupAddress ? t('addPickupAddressToRoute') : t('addDeliveryAddressToRoute'),
                            onClick: () => {
                                popupOptionsResult = [...this.popup.getOptions()]
                                addToRoute = true
                                this.popup.close()
                            },
                            style: {
                                width: 'unset'
                            }
                        },
                        {
                            variant: 'outline-white',
                            label: isPickupAddress ? t('doNotAddPickupAddress') : t('doNotAddDeliveryAddress'),
                            onClick: () => {
                                doNotAddToRoute = true
                                popupOptionsResult = [...this.popup.getOptions()]
                                this.popup.close()
                            },
                            style: {
                                width: 'unset'
                            }
                        },
                        {
                            variant: 'outline-white',
                            label: t('cancelScan'),
                            onClick: () => {
                                cancelled = true
                                this.popup.close()
                                this.setState({hasScanned: originalScanned.length > 0, scanned: originalScanned})
                            },
                            style: {
                                width: 'unset'
                            }
                        }
                    ])

                    this.popup.setOptions([
                        {
                            title: isPickupAddress ? t('neverAddPickupForAddress') : t('neverAddDeliveryForAddress'),
                            value: 'skipScannedOrderPopup',
                            ellipsis: false
                        }
                    ], true)

                    await this.popup.openBoolean(t('addOrder'), isPickupAddress ? t('pickupAddressNotInRoute') : t('deliveryAddressNotInRoute'))

                    const skipScannedOrderPopupResult = popupOptionsResult && popupOptionsResult.find((option) => option.value === 'skipScannedOrderPopup')?.selected

                    this.setState({skipScannedOrderPopup: skipScannedOrderPopupResult ?? false})

                    let takenAlong = activeStops.some((stop) => stop.colli.some((collo) => collo.barcode === barcode))

                    // At a pickup the collo is also taken along when its own order joins the route
                    if (!cancelled && !takenAlong && (doNotAddToRoute || (addToRoute && type === 'pickup'))) {
                        takenAlong = await addUnknownBarcode(true)
                    }

                    if (addToRoute) {
                        if (scannedOrder.colli.length > 1) {
                            if (!await this.popup.open(t('addOrder'), t('addOrderWithColli', scannedOrder.colli.length))) return
                            this.popup.close()
                        }

                        if (showWarningOnAddExistingOrder) {
                            if (!await this.popup.open(t('addOrder'), t('addOrderToRouteConfirm'))) return
                            this.popup.close()
                        }

                        await emit('orders.addToRoute', {ids: [scannedOrder._id], routeId: route._id, lockRouteAfterPlanning: false})

                        await emit('orders.scan', {id: scannedOrder._id, barcode})

                        this.scanFrame?.setMessage(t('orderAddedToRoute'))
                    } else if (doNotAddToRoute && isPickupAddress && takenAlong) {
                        // The collo is taken along without its own pickup order joining the route, so register the
                        // scan there too. Otherwise it keeps waiting to be collected in a route nobody will drive.
                        await emit('orders.scan', {id: scannedOrder._id, barcode})
                    }
                }
            } catch (error) {
                this.popup.setError(typeof error === 'string' ? error : error?.message)
            }
        }

        if (!foundOrder && !showedScannedOrderPopup) {
            if (!['yes', type === 'pickup' ? 'pickup' : 'deliver'].includes(allowAddCollo)) {
                if (originalScanned.length === 0) {
                    this.setState({hasScanned: false})
                }

                this.scanFrame?.setError(t('noColloForBarcode', barcode))
            } else {
                await addUnknownBarcode()
            }
        }
    }

    onClickCamera() {
        if (this.state.images.length >= MAX_IMAGES) {
            this.popup.setError(t('maxImages'))
            return
        }

        this.setState({showCamera: true})
    }

    onCompleteCamera(newImages) {
        this.setState((prevState) => ({images: [...prevState.images, ...newImages].slice(0, MAX_IMAGES), showCamera: false, errors: []}))
    }

    async onSelectImages(event) {
        const files = [...event.target.files]
        this.filepicker.value = ''

        // One at a time, so only one full-size photo is in memory at once
        for (const file of files) {
            if (this.state.images.length >= MAX_IMAGES) {
                this.popup.setError(t('maxImages'))
                return
            }

            try {
                const dataurl = await fileToJpegDataUrl(file)

                await new Promise((resolve) => this.setState((prevState) => ({images: [...prevState.images, dataurl], errors: []}), resolve))
            } catch (err) {
                console.error(err)
            }
        }
    }

    async onClickCopy(address) {
        const text = `${address.street} ${address.nr}${address.addition} ${address.city}`

        if (navigator?.clipboard) {
            try {
                await navigator.clipboard.writeText(text)

                clearTimeout(this.tooltipTimeout)
                this.setState({showCopyTooltip: true})
                this.tooltipTimeout = setTimeout(() => this.setState({showCopyTooltip: false}), 2000)
            } catch (err) {
                console.log(err)
            }
        }
    }

    async onClickAddAddress() {
        const stop = await this.chooseStop(t('addAddress'), t('chooseStop'))

        if (stop) {
            this.addAddressStop = stop
            this.addAddressModal.open(stop.order.customer, 'delivery')
        }
    }

    // The colli of a delivery address the messenger added are picked up at this stop
    onAddAddressColli(addedColli) {
        const stop = this.addAddressStop
        const scanned = [...this.state.scanned]

        if (!stop) {
            return
        }

        const newColli = addedColli.map((collo, index) => {
            const barcode = collo.barcode === 'no barcode' ? '' : collo.barcode

            if (barcode) {
                scanned.push(barcode)
            }

            return {
                index: stop.order.colli.length + index,
                type: '',
                description: '',
                weight: 0,
                length: 0,
                width: 0,
                height: 0,
                barcode,
                pickupAddressIndex: stop.addressIndex,
                status: colloStatuses.pickup.ok,
                reason: '',
                isNewCollo: true
            }
        })

        stop.order.colli.push(...newColli)
        stop.colli.push(...newColli)

        this.setState({stops: [...this.state.stops], scanned: _.uniq(scanned), errors: []})
    }

    onRemoveImage() {
        const {images, selectedImageIndex} = this.state

        if (selectedImageIndex < 0 || selectedImageIndex >= images.length) {
            return
        }

        const newImages = [...images]
        newImages.splice(selectedImageIndex, 1)

        this.setState({images: newImages, showImageLightbox: false, selectedImageIndex: -1, errors: []})
    }

    async onClickEditCustomOptions() {
        const {reseller} = this.props
        const stops = [...this.state.stops]
        const activeStops = this.activeStops()

        let selectedStops = activeStops

        if (activeStops.length > 1) {
            const choice = await this.popup.openOptions(t('editOptions'), '', [
                {title: t('allStops'), value: 'all'},
                {title: t('oneStop'), value: 'one'}
            ])
            if (!choice) return

            if (choice.value === 'one') {
                const option = await this.popup.openOptions(t('editOptions'), t('chooseStop'), activeStops.map((stop) => (
                    <ListItem key={stop.id} onClick={() => this.popup.onClickOption({value: stop.id})} style={{padding: '8px 0'}}>
                        <div style={{flex: 1, minWidth: 0}}>
                            <S1 ellipsis translate='no'>{stopName(stop)}</S1>
                            <P ellipsis translate='no'>{stopSender(stop)}</P>
                        </div>
                    </ListItem>
                )))
                if (!option) return

                selectedStops = activeStops.filter((stop) => stop.id === option.value)
            }
        }

        // An option is checked when every selected stop has it. Only checking or unchecking an option changes it, so
        // options that some of the stops have stay as they are.
        const initialOptions = (reseller.settings.orders.customOptions || []).filter((option) => selectedStops.every((stop) => stop.customOptions.includes(option.id))).map((option) => option.id)

        this.customOptionsRef.setInputs(reseller.settings.orders.customOptions?.map((option) => ({
            type: 'checkbox',
            label: <Badge color={option.color}>{option.name}</Badge>,
            value: initialOptions.includes(option.id),
            name: option.id,
            style: {
                height: 56
            }
        })))

        const result = await this.customOptionsRef.open(t('editOptions'))
        if (!result) return
        this.customOptionsRef.close()

        const checkedOptions = Object.entries(result).filter(([name, value]) => value && name !== 'batchId').map(([name]) => name)
        const addedOptions = checkedOptions.filter((optionId) => !initialOptions.includes(optionId))
        const removedOptions = initialOptions.filter((optionId) => !checkedOptions.includes(optionId))

        selectedStops.forEach((stop) => {
            stop.customOptions = _.uniq([...stop.customOptions.filter((optionId) => !removedOptions.includes(optionId)), ...addedOptions])
        })

        this.setState({stops})
    }

    validate() {
        const {type, possible, deliveredAtNeighbors, nrNeighbor, reason, reasonSpecification, signee, comment, ageVerified, documentId, images} = this.state

        const handledStops = this.handledStops()
        const options = stopBundles.combineOptions(handledStops.map((stop) => stop.address))

        const errors = []

        if (options.imageRequired && !images?.length) {
            errors.unshift(t('addImage'))
        }

        if (handledStops.length && this.activeStops().some((stop) => stop.packages.some((packaging) => !packaging.status))) {
            errors.unshift(t('fillInPackagingStatus'))
        }

        if (!possible && reason === 'other' && !reasonSpecification && !comment) {
            this.commentInput?.setInvalid()
            errors.unshift(t('fillInComment'))
        }

        if (type === 'delivery') {
            // Every verification code is checked against its own stop
            handledStops.forEach((stop) => {
                if (stop.address.verificationCode && stop.verificationCode !== stop.address.verificationCode) {
                    this.verificationCodeInputs[stop.id]?.setInvalid()
                    errors.unshift(t('verificationCodeOfStopIncorrect', stopName(stop)))
                }
            })

            if (options.idCheck && documentId.length < 4) {
                this.documentIdInput?.setInvalid()
                errors.unshift(t('checkRecipientId'))
            }

            if (options.minimumAge && !ageVerified) {
                errors.unshift(t('checkRecipientAge'))
            }

            if ((options.nameRequired || options.signatureRequired || (deliveredAtNeighbors && options.signatureNeighbors)) && !signee) {
                this.signeeInput?.setInvalid()
                errors.unshift(t('fillInRecipientName'))
            }

            if (handledStops.length && deliveredAtNeighbors && !nrNeighbor) {
                this.nrInput?.setInvalid()
                errors.unshift(t('fillInHouseNumber'))
            }
        }

        this.setState({errors})

        return errors.length === 0
    }

    signatureRequired() {
        const {type, deliveredAtNeighbors, signature, hasSignature} = this.state
        const options = stopBundles.combineOptions(this.handledStops().map((stop) => stop.address))

        // A changed stop keeps the signature it was completed with
        return type === 'delivery' && !signature && !hasSignature && (options.signatureRequired || (deliveredAtNeighbors && options.signatureNeighbors))
    }

    async onClickSubmit() {
        const {type, possible} = this.state
        const {reseller} = this.props

        if (!this.validate()) {
            return
        }

        const activeStops = this.activeStops()

        // Colli that still have no status (scanning required, but not scanned) need a reason
        if (possible && activeStops.some((stop) => stop.colli.some((collo) => !collo.status))) {
            const popup = type === 'pickup' ? this.pickupPopup : this.deliverPopup
            const colli = await popup.open(activeStops.flatMap((stop) => stop.colli), reseller)

            popup.close()

            let colloIndex = 0

            activeStops.forEach((stop) => {
                stop.colli = colli.slice(colloIndex, colloIndex + stop.colli.length)
                colloIndex += stop.colli.length
            })

            this.setState({stops: [...this.state.stops]})
        }

        if (this.signatureRequired()) {
            window.blur()

            setTimeout(() => {
                this.setState({view: 'signature'})
            }, 200)
        } else {
            this.onSubmit()
        }
    }

    async onSubmit() {
        const {type, edit, possible, deliveredAtNeighbors, deliveredInMailbox, nrNeighbor, signee, signature, documentId, comment, images, reasonSpecification} = this.state
        let {location} = this.state
        const {history, reseller, shift} = this.props

        const activeStops = this.activeStops()
        const bundleOptions = stopBundles.combineOptions(activeStops.map((stop) => stop.address))
        const okStatus = colloStatuses[type].ok

        try {
            if (type === 'delivery' && possible && bundleOptions.mailboxDelivery && !deliveredInMailbox) {
                const result = await this.confirmPopup.openBoolean(t('attention'), t('notDeliveredInMailboxConfirm'), questionOptions())

                if (!result) {
                    return
                }
            }

            this.startSubmitProgress(t('submitPreparing'))

            try {
                if (!location?.lat) {
                    this.setState({submitProcess: t('submitGettingLocation')})
                    // A completed stop can be changed after the messenger has left
                    location = await geolocation.getCurrentPosition(bundleOptions.gpsRequired && !edit)
                }

                // The distance to the address is checked once for the whole bundle
                const position = activeStops.find((stop) => stop.address.position)?.address.position

                if (type === 'delivery' && location && position && !edit) {
                    this.setState({submitProcess: t('submitCalculatingDistance')})
                    const distance = calcDistance(location, position)
                    const maxDeliveryRadius = parseInt(reseller.settings.maxDeliveryRadius) || 40
                    const isOutsideRadius = distance > maxDeliveryRadius + location.accuracy
                    const deliveryRadiusWarning = reseller.settings.deliveryRadiusWarning || ''

                    if (deliveryRadiusWarning === 'notallowed' && isOutsideRadius) {
                        this.stopSubmitProgress()
                        await this.alertPopup.openAlert(t('attention'), t('outsideDeliveryRadiusNotAllowed', maxDeliveryRadius))
                        return
                    }

                    if (deliveryRadiusWarning === 'warning' && isOutsideRadius) {
                        this.setState({submitProcess: t('submitWaitingForConfirmation')})
                        const answer = await this.confirmPopup.openBoolean(t('attention'), t('outsideDeliveryRadiusWarning', maxDeliveryRadius), questionOptions())

                        if (!answer) {
                            this.stopSubmitProgress()
                            return
                        }
                    }
                }
            } catch {
                await this.alertPopup.openAlert(t('gpsRequired'), t('gpsRequiredText'), {actionLabel: 'Help', onAction: () => utils.onClickHelp('camera-en-locatietoestemming')})

                this.stopSubmitProgress()
                return
            }

            const scanned = possible ? this.state.scanned : []

            const stops = activeStops.map((stop) => {
                const colli = structuredClone(stop.colli)

                colli.forEach((collo) => {
                    if (reasonSpecification) {
                        collo.reasonSpecification = reasonSpecification
                    }

                    if (type === 'delivery' && collo.status === okStatus) {
                        if (deliveredAtNeighbors) {
                            collo.deliveredAtNeighbors = true
                            collo.nrNeighbor = nrNeighbor
                        } else if (deliveredInMailbox || (bundleOptions.mixedMailboxDelivery && stop.address.mailboxDelivery)) {
                            // A bundle with and without mailbox option has no mailbox choice, its mailbox parcels are
                            // still delivered in the mailbox
                            collo.deliveredInMailbox = true
                        }
                    }
                })

                const barcodes = [...stop.colli, ...stop.packages].map((item) => item.barcode).filter(Boolean)
                const customOptionsChanged = !_.isEqual([...stop.customOptions].sort(), [...(stop.address.customOptions || [])].sort())

                const bundleStop = {
                    id: stop.order._id,
                    addressIndex: stop.addressIndex,
                    colli,
                    packages: possible ? stop.packages : [],
                    // The scans of a bundle are split over its stops, one stop keeps all of them (e.g. emballage of a corrected stop)
                    scanned: activeStops.length > 1 ? scanned.filter((barcode) => barcodes.includes(barcode)) : scanned,
                    customOptions: customOptionsChanged ? stop.customOptions : undefined
                }

                if (type === 'delivery') {
                    const signatureRequired = stop.address.signatureRequired || (deliveredAtNeighbors && stop.address.signatureNeighbors)

                    // The name and signature are only stored at the stops that require them
                    bundleStop.signee = signatureRequired || stop.address.nameRequired ? signee : ''
                    bundleStop.signature = signatureRequired ? signature : ''
                    bundleStop.documentId = stop.address.idCheck ? documentId : ''
                }

                return bundleStop
            })

            this.setState({submitProcess: t('submitWaitingForServer')})

            // Photos kept from the completion that is changed are sent by id, new photos as image
            const newImages = images.filter((image) => typeof image === 'string')
            const keptImageIds = images.filter((image) => typeof image !== 'string').map((image) => image.id)

            const {errors} = await emit(type === 'pickup' ? 'orders.pickup' : 'orders.deliver', {stops, comment, images: newImages, keptImageIds, location, shiftId: shift?._id, correction: edit})

            if (errors?.length) {
                // Stops that failed stay open in the bundle, the others are done
                const failedStops = activeStops.filter((stop) => errors.some((error) => `${error.id}` === `${stop.order._id}` && error.addressIndex === stop.addressIndex))

                this.stopSubmitProgress({
                    stops: this.state.stops.filter((stop) => !stop.ready || failedStops.includes(stop)),
                    signature: '',
                    errors: errors.map((error) => {
                        const stop = failedStops.find((stop) => `${error.id}` === `${stop.order._id}` && error.addressIndex === stop.addressIndex)

                        return stop && activeStops.length > 1 ? `${stopName(stop)}: ${error.error}` : error.error
                    })
                })
            } else {
                this.stopSubmitProgress()
                history.replace(localStorage.lastView || '/koerier/adressen')
            }
        } catch (err) {
            this.stopSubmitProgress({error: err.message})
        }
    }

    // The colli and emballage of all stops in one list, the colli are numbered across the stops
    renderColli(isScanView) {
        const {type, possible, scanned, hasScanned} = this.state
        const {reseller} = this.props

        const activeStops = this.activeStops()
        const stopByCollo = new Map(activeStops.flatMap((stop) => stop.colli.map((collo) => [collo, stop])))
        const colli = [...stopByCollo.keys()]
        const packages = activeStops.flatMap((stop) => stop.packages)
        const colloNumber = (collo) => colli.indexOf(collo) + 1

        if (!possible || (!colli.length && !packages.length)) {
            return null
        }

        return (
            <div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 12}}>
                {!!colli.length &&
                    <ColliList
                        type={type}
                        colli={colli}
                        scanned={scanned}
                        hasScanned={hasScanned}
                        isScanRequired={(collo) => stopByCollo.get(collo).address.scanRequired}
                        colloNumber={colloNumber}
                        isScanView={isScanView}
                        reseller={reseller}
                        onClickCollo={(collo) => this.onClickCollo(stopByCollo.get(collo), collo, colloNumber(collo))}
                    />
                }

                {!!packages.length &&
                    <PackagesList
                        style={{marginTop: 3}}
                        packages={packages}
                        packagingIds={_.uniq(activeStops.flatMap((stop) => stop.order.packagingIds || []))}
                        isScanView={isScanView}
                        onClickPackaging={(index) => this.onClickPackaging(packages[index])}
                    />
                }
            </div>
        )
    }

    render() {
        const {view, type, stops, route, edit, possible, status, reason, reasonSpecification, deliveredAtNeighbors, nrNeighbor, deliveredInMailbox, signee, ageVerified, documentId, comment, scanned, hasScanned, images, showCamera, showImageLightbox, selectedImageIndex, showCopyTooltip, expandSenders, expandDeliveryAddresses, customers, addressBook, errors, loading, error, submitProcess, showSlowSubmitWarning} = this.state
        const {reseller, user, history, branding, shift, onClickNavigation} = this.props

        if (!stops) {
            if (!error) {
                return <div />
            }

            return (
                <>
                    <TopBar
                        reseller={reseller}
                        user={user}
                        history={history}
                        showAccount={true}
                        showBack={true}
                        onClickBack={() => history.goBack()}
                        branding={branding}
                    />

                    <Alert variant='error' style={{marginBottom: 6, width: '90%', marginTop: 12}}>{error}</Alert>
                </>
            )
        }

        const activeStops = this.activeStops()
        const firstAddress = stops[0].address
        const options = stopBundles.combineOptions(activeStops.map((stop) => stop.address))
        const handledOptions = stopBundles.combineOptions(this.handledStops().map((stop) => stop.address))
        const bundleReasons = this.bundleReasons()
        const reasonSpecifications = this.reasonSpecifications()
        const allColli = activeStops.flatMap((stop) => stop.colli)
        const someHandled = possible && allColli.some((collo) => collo.status === colloStatuses[type].ok)
        const messengerRouteSettings = resolveMessengerRouteSettings(route, reseller.settings)
        const allowMessengerEditCustomOptions = messengerRouteSettings.allowMessengerEditCustomOptions
        // Texts of one of the stops of a bundle start with the name of that stop
        const stopPrefix = (stop) => activeStops.length > 1 ? `${stopName(stop)}: ` : ''
        const nameRequired = handledOptions.signatureRequired || handledOptions.nameRequired || (deliveredAtNeighbors && handledOptions.signatureNeighbors)
        const autoFillName = activeStops.map((stop) => stop.address.attention || (!stop.address.isBusiness && stop.address.name)).find(Boolean)

        if (view === 'signature') {
            return (
                <>
                    <TopBar
                        reseller={reseller}
                        user={user}
                        history={history}
                        showBack={true}
                        onClickBack={() => this.setState({view: 'main'})}
                        showAccount={true}
                        branding={branding}
                    />

                    <Signature
                        order={activeStops[0].order}
                        colli={allColli}
                        address={activeStops.length > 1 ? {...firstAddress, name: _.uniq(activeStops.map(stopName)).join(', '), attention: ''} : activeStops[0].address}
                        senderName={_.uniq(activeStops.map(stopSender)).join(', ')}
                        branding={branding}
                        onConfirm={(signature) => {
                            this.setState({view: 'main', signature}, () => {
                                this.onSubmit()
                            })
                        }}
                    />
                </>
            )
        }

        if (view === 'scan') {
            return (
                <>
                    <TopBar
                        reseller={reseller}
                        user={user}
                        history={history}
                        showBack={true}
                        onClickBack={() => {
                            activeStops.forEach((stop) => {
                                stop.colli.forEach((collo) => {
                                    if (collo.status === '' && !hasScanned && !stop.address.scanRequired) {
                                        collo.status = colloStatuses[type].ok
                                    }
                                })
                            })

                            this.setState({view: 'main', stops: [...stops]})
                        }}
                        showAccount={true}
                        branding={branding}
                    />

                    <ScanFrame
                        maxHeight='45vh'
                        onScan={this.onScan.bind(this)}
                        onConfirm={() => this.setState({view: 'main'})}
                        ref={(ref) => this.scanFrame = ref}
                    />

                    <ScrollContainer>
                        <div style={{width: '95%', margin: '24px auto 0 auto'}}>
                            <H5 style={{marginBottom: 24}}>{t('colli')}</H5>
                        </div>

                        {this.renderColli(true)}
                    </ScrollContainer>

                    <Row style={{flexShrink: 0, marginBottom: 6, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                        <Button
                            variant='solid'
                            color={branding?.color || Colors.brandColor}
                            style={{width: '100%'}}
                            size='xl'
                            icon='mdi mdi-check'
                            onClick={() => this.setState({view: 'main'})}
                        />
                    </Row>

                    <Popup ref={(ref) => this.confirmPopup = ref} />
                    <LinkBarcodePopup ref={(ref) => this.linkBarcodePopup = ref} />
                    <Popup closeButton showOptionRadioButton ref={(ref) => this.popup = ref} />
                </>
            )
        }

        const otherPackages = activeStops.some((stop) => stop.packages.some((packaging) => !(stop.order.packagingIds || []).includes(packaging._id)))
        const lastAttemptStops = activeStops.filter((stop) => stop.order.nrOfDeliveries > 0 && (stop.address.nrOfAttempts || 0) >= ((stop.order.nrOfDeliveries || 0) - 1))
        const changed = scanned.length > 0 || images?.length > 0 || comment || activeStops.some((stop) => !_.isEqual(stop.originalColli, stop.colli))
        const isRetour = type === 'delivery' && activeStops.length > 0 && activeStops.every((stop) => isRetourOrder(stop.order))
        const senderStops = _.uniqBy(activeStops.length ? activeStops : stops, (stop) => `${stop.order._id}`)
        const senderContact = senderStops.some((stop) => stop.order.phone || stop.order.contact)
        const attachments = activeStops.flatMap((stop) => stop.address.attachments || [])
        const deliveryAddresses = type === 'pickup' ? _.uniqBy(activeStops.flatMap((stop) => stopDeliveryAddresses(stop).map((address) => ({...address, key: `${stop.order._id} ${address.index}`}))), 'key') : []
        const isReady = stops.some((stop) => stop.address.isReady)

        return (
            <>
                <TopBar
                    reseller={reseller}
                    user={user}
                    history={history}
                    showAccount={true}
                    showBack={true}
                    onClickBack={() => {
                        if (!possible) {
                            this.onChangePossible(true)
                        } else if (changed) {
                            this.popup.open(t('goBack'), t('goBackConfirm'), () => {
                                history.goBack()
                                this.popup.close()
                            })
                        } else {
                            history.goBack()
                        }
                    }}
                    branding={branding}
                />

                <ScrollContainer>
                    <div style={{position: 'relative', display: 'flex', alignItems: 'center', width: possible ? '90%' : '100%', height: 48, marginBottom: 6, flexShrink: 0, background: possible ? '' : Colors.grey60}}>
                        {possible &&
                            <div style={{position: 'absolute', left: -12, width: 6, height: 36, borderRadius: '4px 0px 0px 4px', background: isRetour ? Colors.retour : Colors[type]}} />
                        }

                        {possible ?
                            <H5 style={{marginBottom: 0}}>{type === 'pickup' ? t('pickupAction') : isRetour ? t('deliverRetourAction') : t('deliverAction')}</H5> :
                            <H5 style={{marginLeft: '5%', marginBottom: 0, color: '#ffffff'}}>{type === 'pickup' ? t('pickupNotPossible') : t('deliveryNotPossible')}</H5>
                        }

                        <div style={{flex: 1}} />

                        {possible &&
                            <Button
                                variant='outline-white'
                                label={type === 'pickup' ? t('pickupNotPossible') : t('deliveryNotPossible')}
                                disabled={activeStops.length > 1 && !bundleReasons.reasons.length}
                                onClick={this.onChangePossible.bind(this, false)}
                            />
                        }
                    </div>

                    {possible && activeStops.length > 1 && !bundleReasons.reasons.length &&
                        <Alert variant='info' style={{width: '90%', marginBottom: 6}}>
                            {t('noSharedReasons')}
                        </Alert>
                    }

                    {/* TODO remove after Px pilot */}
                    {otherPackages &&
                        <Alert variant='warning' style={{width: '90%', marginBottom: 6}}>
                            {t('pxAtAddress')}
                        </Alert>
                    }

                    {type === 'delivery' && lastAttemptStops.length > 0 &&
                        <Alert variant='warning' style={{width: '90%', marginBottom: 6}}>
                            <span translate='no'>{activeStops.length > 1 ? `${t('lastDeliveryAttempt')}: ${lastAttemptStops.map(stopName).join(', ')}` : t('lastDeliveryAttempt')}</span>
                        </Alert>
                    }

                    {type === 'delivery' && options.mailboxDelivery &&
                        <Alert variant='warning' style={{width: '90%', marginBottom: 6}}>
                            {t('mailboxParcel')}
                        </Alert>
                    }

                    {type === 'delivery' && options.refrigerated &&
                        <Alert variant='warning' style={{width: '90%', marginBottom: 6}}>
                            {t('transportRefrigerated')}
                        </Alert>
                    }

                    {type === 'delivery' && options.statedAddressOnly && !options.mailboxDelivery &&
                        <Alert variant='warning' style={{width: '90%', marginBottom: 6}}>
                            {t('notAtNeighbors')}
                        </Alert>
                    }

                    {_.uniqBy(activeStops.filter((stop) => stop.order.notes), (stop) => stop.order._id).map((stop) => (
                        <Alert key={stop.id} variant='warning' style={{width: '90%', marginBottom: 6}}>
                            <P translate='no' style={{whiteSpace: 'pre-line'}}>{`${stopPrefix(stop)}${stop.order.notes}`}</P>
                        </Alert>
                    ))}

                    <Row style={{alignItems: 'center', width: '90%', marginBottom: 12, marginTop: 6}}>
                        {type === 'delivery' && possible && (nameRequired || deliveredAtNeighbors) &&
                            (
                                (nameRequired && !signee) || (deliveredAtNeighbors && !nrNeighbor) ?
                                    <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' /> :
                                    <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' />
                            )
                        }

                        <H5 style={{flex: 1, marginBottom: 0}}>{type === 'pickup' ? t('collectionAddress') : t('recipient')}</H5>

                        <OptionIcons options={options} colliCount={allColli.length} color={Colors.textDark} />
                    </Row>

                    <Card style={{display: 'flex', flex: 0, width: '90%', marginBottom: 6}}>
                        <Stack style={{flex: 1}}>
                            <Stack style={{flex: 1}} onClick={this.onClickCopy.bind(this, firstAddress)}>
                                <P translate='no'>{`${firstAddress.street} ${firstAddress.nr}${firstAddress.addition}`}</P>
                                <P translate='no'>{firstAddress.street2}</P>
                                <P translate='no' style={{marginBottom: 12}}>{`${firstAddress.postalCode} ${firstAddress.city} (${firstAddress.country})`}</P>
                            </Stack>

                            {/* Stops with the same name and attention are shown once */}
                            {Object.values(_.groupBy(stops, (stop) => `${stopName(stop)}\n${stop.address.attention || ''}`)).map((nameStops) => {
                                const stop = nameStops.find((stop) => stop.ready) || nameStops[0]
                                const phone = nameStops.find((stop) => stop.ready && stop.address.phone)?.address.phone

                                return (
                                    <div key={stop.id} style={{display: 'flex', alignItems: 'center', marginBottom: 3}}>
                                        <Icon style={{marginRight: 6, fontSize: 16, color: stop.ready ? Colors.textDark : Colors.textMedium}} icon={stop.address.isBusiness || stop.address.attention ? 'mdi mdi-store' : 'mdi mdi-account'} />

                                        <S1 translate='no' style={{flex: 1, color: stop.ready ? Colors.textDark : Colors.textMedium}}>
                                            {`${stopName(stop)}${stop.address.attention ? ` (${t('attentionOf')} ${stop.address.attention})` : ''}${stop.ready ? '' : ` (${_.uniq(nameStops.map((stop) => stop.status)).join(', ')})`}`}
                                        </S1>

                                        {phone &&
                                            <a style={{textDecoration: 'none'}} href={`tel:${phone}`}>
                                                <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-phone' />
                                            </a>
                                        }
                                    </div>
                                )
                            })}

                            {attachments.length > 0 &&
                                <Row style={{flexShrink: 0, marginTop: 12, flexWrap: 'wrap'}}>
                                    <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-paperclip' />

                                    {attachments.map((attachment) => (
                                        <Link key={attachment.fileId} style={{lineHeight: 'normal'}} onClick={() => openAttachment(attachment)}>
                                            {attachment.fileName}
                                        </Link>
                                    ))}
                                </Row>
                            }
                        </Stack>

                        <Stack style={{alignItems: 'flex-end', width: 90}}>
                            <P translate='no' ellipsis>{`${firstAddress.startTime} - ${firstAddress.endTime}`}</P>

                            <Row style={{flexShrink: 0, justifyContent: 'flex-end', marginTop: 12}}>
                                <IconButton
                                    style={{marginRight: 12}}
                                    disabled={!isReady}
                                    onClick={() => history.push('/koerier/kaart', {orderId: stops[0].order._id, addressIndex: stops[0].addressIndex})}
                                >
                                    <Icon style={{marginRight: 6, fontSize: 24}} icon='mdi mdi-map' />
                                </IconButton>

                                <IconButton disabled={!isReady} onClick={() => onClickNavigation(user, route, firstAddress)}>
                                    <Icon style={{marginRight: 6, fontSize: 24}} icon='mdi mdi-navigation-outline' />
                                </IconButton>
                            </Row>
                        </Stack>
                    </Card>

                    <Card style={{flex: 0, flexShrink: 0, width: '90%', marginBottom: 6}}>
                        <Row style={{flexShrink: 0}} onClick={() => this.setState({expandSenders: !expandSenders})}>
                            {senderContact &&
                                <Icon style={{marginRight: 6, fontSize: 16}} icon={expandSenders ? 'mdi mdi-menu-down' : 'mdi mdi-menu-right'} />
                            }

                            <P style={{flex: 1, marginLeft: senderContact ? 0 : 21}}>
                                {`${type === 'pickup' ? t('principal') : t('consignor')}: `}
                                <span translate='no'>{_.uniq(senderStops.map(stopSender)).join(', ')}</span>
                            </P>
                        </Row>

                        {senderStops.filter((stop) => isRetourOrder(stop.order) && stop.order.originalAddresses?.[0]).map((stop) => (
                            <OriginalAddressRow key={stop.id} address={stop.order.originalAddresses[0]} style={{marginTop: 6}} />
                        ))}

                        {expandSenders && senderStops.filter((stop) => stop.order.phone || stop.order.contact).map((stop) => (
                            <Stack key={stop.id} style={{flex: 1, marginTop: 12}}>
                                {senderStops.length > 1 &&
                                    <S1 translate='no'>{stopSender(stop)}</S1>
                                }

                                {stop.order.contact &&
                                    <Row style={{flexShrink: 0}}>
                                        <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-account' />
                                        <P translate='no'>{stop.order.contact}</P>
                                    </Row>
                                }

                                {stop.order.phone &&
                                    <Row style={{flexShrink: 0}}>
                                        <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-phone' />

                                        <a style={{textDecoration: 'none'}} href={`tel:${stop.order.phone}`}>
                                            <P translate='no'>{stop.order.phone}</P>
                                        </a>
                                    </Row>
                                }
                            </Stack>
                        ))}
                    </Card>

                    {deliveryAddresses.length > 0 &&
                        <Card style={{flex: 0, width: '90%', marginBottom: 6}} onClick={() => this.setState({expandDeliveryAddresses: !expandDeliveryAddresses})}>
                            <div style={{display: 'flex'}}>
                                <Icon style={{marginRight: 6, fontSize: 16}} icon={expandDeliveryAddresses ? 'mdi mdi-menu-down' : 'mdi mdi-menu-right'} />

                                <div>
                                    <P style={{flex: 1}} translate='no'>
                                        {`${t('deliveryAddress')}: ${deliveryAddresses.length > 1 ?
                                            t('addressCount', deliveryAddresses.length) :
                                            deliveryAddresses[0].isBusiness ? deliveryAddresses[0].name : `${deliveryAddresses[0].street} ${deliveryAddresses[0].nr}${deliveryAddresses[0].addition}, ${deliveryAddresses[0].city}`}`}
                                    </P>

                                    {expandDeliveryAddresses && deliveryAddresses.map((address) => (
                                        <div key={address.key} style={{marginTop: 12}}>
                                            <P translate='no'>{address.name}</P>
                                            {address.attention && <P translate='no'>{`${t('attentionOf')} ${address.attention}`}</P>}
                                            <P translate='no'>{`${address.street} ${address.nr}${address.addition}`}</P>
                                            <P translate='no'>{`${address.postalCode} ${address.city}`}</P>
                                            {address.phone && <P translate='no'>{address.phone}</P>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Card>
                    }

                    {activeStops.filter((stop) => stop.address.instructions).map((stop) => (
                        <Card key={stop.id} style={{display: 'flex', flex: 0, width: '90%', marginBottom: 6}}>
                            <Icon style={{marginRight: 6, marginLeft: 6, marginTop: 2}} size='md' icon='mdi mdi-message-outline' />
                            <P translate='no' style={{whiteSpace: 'pre-line'}}>{`${stopPrefix(stop)}${stop.address.instructions}`}</P>
                        </Card>
                    ))}

                    <div style={{height: 6, width: '90%'}} />

                    {!possible &&
                        <>
                            <FormStack style={{width: '90%', marginTop: formSpacing.rowGap, marginBottom: formSpacing.rowGap}}>
                                <Select
                                    label={t('reason')}
                                    value={type === 'pickup' ? reason : status}
                                    subvalue={type === 'pickup' ? undefined : reason}
                                    options={bundleReasons.reasons.map((reason) => type === 'pickup' ?
                                        {value: reason, title: dbCodes.colloReasons[reason]} :
                                        {
                                            value: reason.split(';')[0],
                                            subvalue: reason.split(';')[1] || '',
                                            title: dbCodes.colloReasons[reason.split(';')[1] || reason] || dbCodes.colloStatus[reason]
                                        }
                                    )}
                                    onChange={this.onChangeReason.bind(this)}
                                    ref={(ref) => this.reasonInput = ref}
                                />

                                {reasonSpecifications.length > 0 &&
                                    <Select
                                        style={{marginTop: 18}}
                                        label={t('specification')}
                                        value={reasonSpecifications.findIndex((specification) => specification.specification === reasonSpecification).toString()}
                                        options={reasonSpecifications.map((specification, index) => ({
                                            value: index.toString(),
                                            title: specification.specification
                                        }))}
                                        onChange={(event) => {
                                            this.setState({reasonSpecification: reasonSpecifications[event.target.value].specification})
                                        }}
                                        ref={(ref) => this.reasonSpecificationInput = ref}
                                    />
                                }
                            </FormStack>
                        </>
                    }

                    {type === 'delivery' && possible &&
                        <div style={{display: 'flex', width: '90%', columnGap: formSpacing.columnGap}}>
                            {!options.statedAddressOnly &&
                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    selected={deliveredAtNeighbors}
                                    onClick={() => {
                                        this.setState({deliveredAtNeighbors: !deliveredAtNeighbors, deliveredInMailbox: false, errors: []}, () => {
                                            if (this.state.deliveredAtNeighbors) {
                                                this.nrInput?.focus()
                                            }
                                        })
                                    }}
                                    label={t('deliveredAtNeighbors')}
                                />
                            }

                            {/* A bundle of stops with and without mailbox option has no mailbox choice */}
                            {!deliveredAtNeighbors && !options.signatureRequired && !options.nameRequired && !options.mixedMailboxDelivery &&
                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    selected={deliveredInMailbox}
                                    onClick={() => {
                                        this.setState({deliveredAtNeighbors: false, nrNeighbor: '', deliveredInMailbox: !deliveredInMailbox, errors: []})
                                    }}
                                    label={t('deliveredInMailbox')}
                                />
                            }

                            {deliveredAtNeighbors &&
                                <Input
                                    label={t('houseNumber')}
                                    value={nrNeighbor}
                                    onChange={(event) => this.setState({nrNeighbor: event.target.value, errors: []})}
                                    ref={(ref) => this.nrInput = ref}
                                />
                            }
                        </div>
                    }

                    {type === 'delivery' && possible &&
                        <>
                            <Row style={{flexShrink: 0, width: '90%', alignItems: 'center', columnGap: formSpacing.columnGap, marginTop: 12, marginBottom: 12}}>
                                {(options.signatureRequired || options.nameRequired || (deliveredAtNeighbors && options.signatureNeighbors)) &&
                                    <Input
                                        style={{flex: 1}}
                                        label={t('recipientName')}
                                        value={signee}
                                        onChange={(event) => this.setState({signee: event.target.value, errors: []})}
                                        ref={(ref) => this.signeeInput = ref}
                                    />
                                }

                                {autoFillName && (options.signatureRequired || options.nameRequired || (deliveredAtNeighbors && options.signatureNeighbors)) &&
                                    <Button
                                        variant='outline-white'
                                        icon='mdi mdi-signature-text'
                                        onClick={() => this.setState({signee: autoFillName})}
                                    />
                                }
                            </Row>

                            {options.idCheck &&
                                <>
                                    <Row style={{alignItems: 'center', width: '90%', marginTop: 12, marginBottom: 12}}>
                                        {documentId.length >= 4 ?
                                            <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' /> :
                                            <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' />
                                        }

                                        <H5 style={{marginBottom: 0}}>{t('idCheck')}</H5>
                                    </Row>

                                    <FormStack style={{width: '90%', marginBottom: formSpacing.rowGap}}>
                                        <Input
                                            label={t('documentNumber')}
                                            placeholder={t('lastFourCharacters')}
                                            value={documentId}
                                            onChange={(event) => this.setState({documentId: event.target.value, errors: []})}
                                            ref={(ref) => this.documentIdInput = ref}
                                        />
                                    </FormStack>
                                </>
                            }

                            {options.verificationCode &&
                                <>
                                    <Row style={{alignItems: 'center', width: '90%', marginTop: 12, marginBottom: 12}}>
                                        {activeStops.some((stop) => stop.address.verificationCode && !stop.verificationCode) ?
                                            <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' /> :
                                            <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' />
                                        }

                                        <H5 style={{marginBottom: 0}}>{t('verificationCode')}</H5>
                                    </Row>

                                    <FormStack style={{width: '90%', marginBottom: formSpacing.rowGap}}>
                                        {activeStops.filter((stop) => stop.address.verificationCode).map((stop) => (
                                            <Input
                                                key={stop.id}
                                                label={t('codeOfStop', stopName(stop))}
                                                regex={/^[A-Z,0-9]*$/}
                                                toUpperCase={true}
                                                value={stop.verificationCode}
                                                onChange={(event) => {
                                                    stop.verificationCode = event.target.value
                                                    this.setState({stops: [...stops], errors: []})
                                                }}
                                                ref={(ref) => this.verificationCodeInputs[stop.id] = ref}
                                            />
                                        ))}
                                    </FormStack>
                                </>
                            }

                            {options.minimumAge &&
                                <>
                                    <Row style={{alignItems: 'center', width: '90%', marginTop: 12, marginBottom: 12}}>
                                        {!ageVerified ?
                                            <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' /> :
                                            <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' />
                                        }

                                        <H5 style={{marginBottom: 0}}>{t('ageCheck')}</H5>
                                    </Row>

                                    <Toggle
                                        style={{width: '90%'}}
                                        label={t('recipientOlderThan', options.minimumAge)}
                                        checked={ageVerified}
                                        onChange={() => this.setState({ageVerified: !ageVerified, errors: []})}
                                    />

                                    <S2 style={{width: '90%', marginTop: -6, marginBottom: 12}}>{t('bornBefore', moment().subtract(options.minimumAge, 'year').add(1, 'day').format('DD-MM-YYYY'))}</S2>
                                </>
                            }
                        </>
                    }

                    {possible &&
                        <>
                            {reseller.settings.orders.customOptions?.length > 0 && (
                                <>
                                    {(options.customOptions.length > 0 || allowMessengerEditCustomOptions) && (
                                        <div style={{width: '90%', marginTop: 8}}>
                                            <H5 style={{marginBottom: 12}}>{t('options')}</H5>
                                        </div>
                                    )}

                                    <CustomOptionBadges
                                        style={{width: '90%', gap: 12}}
                                        reseller={reseller}
                                        customOptions={_.uniq(activeStops.flatMap((stop) => stop.customOptions))}
                                    />

                                    {allowMessengerEditCustomOptions && (
                                        <Button
                                            style={{width: '90%', marginTop: 12}}
                                            variant='outline-white'
                                            label={t('editOptions')}
                                            icon='mdi mdi-package-variant-closed-plus'
                                            onClick={this.onClickEditCustomOptions.bind(this)}
                                        />
                                    )}

                                    <Popup ref={(ref) => this.customOptionsRef = ref} />
                                </>
                            )}

                            <Row style={{alignItems: 'center', width: '90%', marginTop: 36, marginBottom: 12}}>
                                {options.scanRequired &&
                                    (allColli.some((collo) => !collo.status) ?
                                        <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' /> :
                                        <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' />
                                    )
                                }

                                <H5 style={{marginBottom: 0}}>{t('colli')}</H5>
                            </Row>

                            <Row style={{width: '90%', marginBottom: 12, gap: 10}}>
                                <Button
                                    style={{flex: 1}}
                                    variant='outline-white'
                                    label={t('scan')}
                                    icon='mdi mdi-barcode-scan'
                                    onClick={() => {
                                        allColli.forEach((collo) => {
                                            if (collo.status === colloStatuses[type].ok && !hasScanned) {
                                                collo.status = ''
                                                collo.reason = ''
                                            }
                                        })

                                        this.setState({view: 'scan', stops: [...stops]})
                                    }}
                                />

                                {type === 'pickup' && messengerRouteSettings.allowAddAddress &&
                                    <Button
                                        style={{flex: 1}}
                                        variant='outline-white'
                                        label={t('addAddress')}
                                        icon='mdi mdi-home-plus-outline'
                                        onClick={this.onClickAddAddress.bind(this)}
                                    />
                                }
                            </Row>

                            {this.renderColli(false)}
                        </>
                    }

                    <Row style={{alignItems: 'center', width: '90%', marginTop: 36, marginBottom: 12}}>
                        {possible && handledOptions.imageRequired &&
                            (!(images?.length > 0) ?
                                <Icon style={{marginRight: 6}} size='md' icon='mdi mdi-alert-circle' /> :
                                <Icon size='md' style={{marginRight: 6, color: Colors.successBright}} icon='mdi mdi-check-circle' />
                            )
                        }

                        <H5 style={{marginBottom: 0}}>{t('photo')}</H5>
                    </Row>

                    <Row style={{width: '90%', marginBottom: 12, columnGap: formSpacing.columnGap}}>
                        <Button
                            style={{flex: 3}}
                            variant='outline-white'
                            icon='mdi mdi-camera'
                            onClick={this.onClickCamera.bind(this)}
                        />

                        <Button
                            style={{flex: 1}}
                            variant='outline-white'
                            icon='mdi mdi-image-multiple-outline'
                            onClick={() => this.filepicker.click()}
                        />
                    </Row>

                    {images?.length > 0 && (
                        <Row style={{width: '90%', marginBottom: 12, gap: 8, flexWrap: 'wrap'}}>
                            {images.map((image, index) => (
                                <img
                                    key={index}
                                    src={imageSrc(image)}
                                    onClick={() => this.setState({showImageLightbox: true, selectedImageIndex: index})}
                                    style={{height: 70, maxWidth: 115, objectFit: 'contain', cursor: 'pointer'}}
                                />
                            ))}
                        </Row>
                    )}

                    <Row style={{alignItems: 'center', width: '90%', marginTop: 36, marginBottom: 12}}>
                        <H5 style={{marginBottom: 0}}>{t('notes')}</H5>
                    </Row>

                    <FormStack style={{width: '90%', marginBottom: formSpacing.rowGap}}>
                        <TextArea
                            label={t('notes')}
                            value={comment}
                            rows={2}
                            onChange={(event) => this.setState({comment: event.target.value, errors: []})}
                            ref={(ref) => this.commentInput = ref}
                        />
                    </FormStack>
                </ScrollContainer>

                {errors.length > 0 && errors.map((error, i) => <Alert key={i} variant='error' style={{marginBottom: 0}}>{error}</Alert>)}
                {error && <Alert variant='error' style={{marginBottom: 0}}>{error}</Alert>}

                {loading && showSlowSubmitWarning && submitProcess &&
                    <Alert variant='warning' style={{marginBottom: 6}}>{t('submitBusy', submitProcess)}</Alert>
                }

                <Row style={{flexShrink: 0, marginBottom: edit ? 12 : 6, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                    {someHandled && this.signatureRequired() ?
                        <Button
                            variant='solid'
                            color={branding?.color || Colors.brandColor}
                            style={{width: '100%'}}
                            size='xl'
                            loading={loading}
                            icon='mdi mdi-fountain-pen-tip'
                            label={t('signature')}
                            disabled={!activeStops.length}
                            onClick={this.onClickSubmit.bind(this)}
                        /> :
                        <Button
                            variant='solid'
                            color={branding?.color || Colors.brandColor}
                            style={{width: '100%'}}
                            size='xl'
                            loading={loading}
                            icon='mdi mdi-check'
                            label={someHandled ? (type === 'pickup' ? t('pickupAction') : t('deliverAction')) : ''}
                            disabled={!activeStops.length}
                            onClick={this.onClickSubmit.bind(this)}
                        />
                    }
                </Row>

                {edit &&
                    <Row style={{flexShrink: 0, marginBottom: 6, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                        <Button
                            variant='outline-white'
                            style={{width: '100%'}}
                            size='xl'
                            disabled={loading}
                            label={t('cancel')}
                            onClick={() => history.goBack()}
                        />
                    </Row>
                }

                <input
                    style={{display: 'none'}}
                    type='file'
                    accept='image/*'
                    multiple
                    ref={(ref) => this.filepicker = ref}
                    onChange={this.onSelectImages.bind(this)}
                />

                {showCamera &&
                    <CameraScreen
                        imageCount={images.length}
                        maxImages={MAX_IMAGES}
                        onComplete={this.onCompleteCamera.bind(this)}
                        onCancel={() => this.setState({showCamera: false})}
                    />
                }

                {type === 'pickup' &&
                    <AddAddressModal
                        ref={(ref) => this.addAddressModal = ref}
                        reseller={reseller}
                        branding={branding}
                        customers={customers}
                        addressBook={addressBook}
                        route={route}
                        shift={shift}
                        onColliAdded={this.onAddAddressColli.bind(this)}
                    />
                }

                <Popup ref={(ref) => this.alertPopup = ref} />
                <Popup ref={(ref) => this.confirmPopup = ref} />
                <LinkBarcodePopup ref={(ref) => this.linkBarcodePopup = ref} />
                <DeliverPopup ref={(ref) => this.deliverPopup = ref} />
                <PickupPopup ref={(ref) => this.pickupPopup = ref} />

                <ImageLightbox
                    show={showImageLightbox}
                    image={selectedImageIndex >= 0 ? imageSrc(images[selectedImageIndex]) : ''}
                    onClose={() => this.setState({showImageLightbox: false})}
                    onRemove={this.onRemoveImage.bind(this)}
                />

                {showCopyTooltip &&
                    <div style={{position: 'fixed', display: 'flex', width: '90%', justifyContent: 'center', bottom: 88}}>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            height: 48,
                            alignItems: 'center',
                            background: 'rgb(50, 50, 50)',
                            color: 'white',
                            width: '80%',
                            borderRadius: 4,
                            paddingLeft: 20,
                            paddingRight: 20,
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: 1.43,
                            letterSpacing: '0.01071em',
                            boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
                        }}
                        >
                            {t('addressCopied')}

                            <Icon
                                style={{marginRight: 6, fontSize: '1.5rem', marginLeft: 'auto'}}
                                icon='mdi mdi-close'
                                onClick={() => {
                                    clearTimeout(this.tooltipTimeout)
                                    this.setState({showCopyTooltip: false})
                                }}
                            />
                        </div>
                    </div>
                }

                <Popup closeButton showOptionRadioButton ref={(ref) => this.popup = ref} />
            </>
        )
    }
}

export default Stop
